module.exports = __webpack_public_path__ + "static/media/warning_amber.a2599b0d.svg";